var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padd30 mt30",staticStyle:{"background-color":"#F4F7FC"}},[_c('van-row',{staticClass:"mt5 mcenter"},[_c('van-col',{staticClass:"font16",attrs:{"span":"24"}},[_c('p',{staticClass:"padd10"},[_vm._v("成都四小牛科技有限公司")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备2021025007号")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }